<template>
  <v-container v-if="pageDataReady.isReady">

    <v-breadcrumbs divider="/" class="ml-1 pb-0">
      <v-breadcrumbs-item
          v-for="breadcrumb in breadcrumbs"
          :key="breadcrumb.name"
          :disabled="typeof breadcrumb.link === 'undefined'"
          :to="typeof breadcrumb.link !== 'undefined' ? breadcrumb.link : ''"
      >
        {{ breadcrumb.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>

    <v-form ref="form" validation @input="checkValidate" class="ml-3">
      <v-layout row>
        <v-flex xs12 lg12 md12>
          <h1 class="my-3">{{title}}</h1>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12 lg8 md8>
          <v-text-field
              label="Наименование рекомендации"
              v-model="recommendationTitle"
              :rules="recommendationTitleRules"
              validate-on-blur
              outline
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12 lg8 md8>
          <v-layout row>
            <v-flex xs4 lg4 md4 class="mr-3">
              <v-text-field
                  label="% от продаж"
                  v-model="bonusPercent"
                  :rules="recommendationNumericRules"
                  validate-on-blur
                  outline
                  suffix="%"
              ></v-text-field>
            </v-flex>
            <v-flex xs4 lg4 md4 class="mr-3">
              <v-text-field
                  label="Максимальный бонус"
                  v-model="bonusMaxSum"
                  validate-on-blur
                  outline
                  suffix="₽"
              ></v-text-field>
            </v-flex>
            <v-flex xs4 lg4 md4>
              <v-text-field
                  label="Вычет за возврат"
                  v-model="refundPercent"
                  validate-on-blur
                  outline
                  suffix="%"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex xs12 lg8 md8>
          <v-layout row>
            <v-flex xs6 lg6 md6 class="mr-3">
              <v-text-field
                  label="Минимальная сумма заказа"
                  v-model="minOrderSum"
                  validate-on-blur
                  outline
                  suffix="₽"
              ></v-text-field>
            </v-flex>
            <v-flex xs6 lg6 md6>
              <v-text-field
                  label="Минимальный вес заказа"
                  v-model="minOrderWeight"
                  validate-on-blur
                  outline
                  suffix="кг"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

      <v-layout row class="pa-0 ma-0">
        <v-flex xs12 lg8 md8>
          <v-textarea
              outline
              name="input-7-4"
              label="Описание"
              rows="10"
              value=""
              v-model="description"
          ></v-textarea>
        </v-flex>
      </v-layout>

      <p class="title">Торговые точки</p>
      <v-layout row class="mb-3">
        <v-flex xs12 lg8 md8 pa-3 class="elevation-1 white">
          <v-progress-circular
              v-if="pointLoading"
              :size="50"
              color="primary"
              indeterminate
          ></v-progress-circular>
          <div v-if="pointTreeData.length > 0 && !pointLoading">
            <tree
                :data="pointTreeData"
                :options="{
                checkbox: true,
                fetchData(node) {
                  if (node.children.length > 0) {
                    return blank()
                  } else {
                    return getPointFolder(node.data.id)
                  }
                },
                treeType: 'pointTree'
              }"
                class="tree--small"
                @node:checked="onPointChecked"
                @node:unchecked="onPointUnchecked"
            />
          </div>
        </v-flex>
      </v-layout>

      <p class="title">Группы товаров</p>
      <v-layout row class="mt-3">
        <v-flex xs12 lg8 md8>
          <div
              class="mb-3 pa-2 elevation-3 white"
              v-for="(productGroup, index) in productGroupList"
              :key="index"
          >
            <v-layout>
              <v-flex xs8 lg8 md8 class="ml-3">
                <v-text-field
                    class="mt-3"
                    :label="'Название'"
                    v-model="productGroup.title"
                    single-line
                    @input="onSetTextProductGroup(index)"
                    outline
                ></v-text-field>
              </v-flex>
              <v-flex xs3 lg3 md3 class="ml-3">
                <v-btn color="primary" class="mt-3 mb-0 case-sku-btn" large @click="onClickSkuSelectBtn(index)">Выбрать SKU</v-btn>
              </v-flex>
            </v-layout>
            <v-layout v-if="productGroup.skuList.length > 0">
              <v-flex xs6 lg6 md6>
                <v-card class="elevation-0 pb-3 mx-3 mb-1">
                  <v-card-text class="text-lg-left font-weight-black pa-0">Список SKU:</v-card-text>
                  <v-card-text class="text-lg-left pa-0" v-for="(product, index) in productGroup.skuList" :key="index">{{product}}</v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>

      <div v-for="(productGroup, index) in productGroupList" :key="index">
        <v-dialog
            v-model="productGroup.dialog"
            max-width="600"
        >
          <v-card>
            <v-card-title class="headline">Список SKU</v-card-title>
            <v-layout row v-if="productGroup.productTreeData.length > 0" class="mt-4">
              <v-flex xs12 lg12 md12 class="ml-2">
                <tree
                    :data="productGroup.productTreeData"
                    :options="{
                    checkbox: true,
                      fetchData(node) {
                        if (node.data.type === 'category') {
                          return getProductBrand(node.data.id, node.data.groupIndex)
                        } else if (node.data.type === 'brand') {
                          return getProductSku(node.data.id, node.data.groupIndex)
                        }
                      }
                    }"
                    class="tree--small case-dialog-tree"
                    @node:checked="onProductSkuChecked"
                    @node:unchecked="onProductSkuUnchecked"
                />
              </v-flex>
            </v-layout>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  color="primary"
                  @click="productGroup.dialog = false"
              >
                Сохранить
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

      <v-layout row class="pa-0 mt-3 mb-3">
        <v-flex xs12 lg12 md12>
          <div class="float-left inline-block">
            <p class="title">Дата начала</p>
            <v-date-picker
                v-model="startDate"
                :reactive="true"
                locale="ru"
                class="mr-3 ml-0 mt-0 mb-3"
                :min="minDate()"
                @input="checkValidate()"
                :first-day-of-week="1"
            ></v-date-picker>
          </div>
          <div class="inline-block">
            <p class="title">Дата окончания</p>
            <v-date-picker
                v-model="endDate"
                :reactive="true"
                locale="ru"
                class="mr-3 ml-0"
                :min="minDate()"
                @input="checkValidate()"
                :first-day-of-week="1"
            ></v-date-picker>
          </div>
        </v-flex>
      </v-layout>

      <v-layout row class="pa-0 ma-0">
        <v-flex xs12 lg6 md6>
          <v-btn
              :loading="loading"
              :disabled="!valid || loading"
              color="primary"
              @click.native="loader = 'loading'"
              class="ma-0"
              @click="onClickCreateRecommendation"
          >
            {{id === null ? 'Создать' : 'Изменить'}}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-form>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      breadcrumbs: [
        {name: 'Главная', link: '/'},
        {name: 'Рекомендации', link: '/recommendations/active'}
      ],
      pageDataReady: {
        isReady: false,
        points: false,
        products: false
      },
      pointListTreeData: [],
      pointFolderIdList: [],
      pointIdList: [],
      pointTreeData: [],
      pointTreeIdCounter: 0,
      pointLoading: false,

      productCategoryTree: [],
      bonusPercent: null,
      bonusMaxSum: null,
      minOrderSum: null,
      minOrderWeight: null,
      refundPercent: null,
      id: null,
      title: 'Новая рекомендация',
      recommendationTitle: null,
      description: null,
      startDate: null,
      endDate: null,
      productTreeIdCounter: 0,
      productGroupList: [
        {
          id: 0,
          title: '',
          pointMinPercent: '',
          skuIdList: [],
          skuList: [],
          treeData: [],
          dialog: false,
          productTreeData: []
        }
      ],
      valid: false,
      recommendationTitleRules: [
        v => !!v || 'Обязательное поле'
      ],
      recommendationNumericRules: [
        v => /^[0-9.]+$/u.test(v) || 'Только числовое значение'
      ]
    }),
    methods: {
      pageDataStatus () {
        if (!this.pageDataReady.points) {
          return false
        }
        if (!this.pageDataReady.products) {
          return false
        }

        this.pageDataReady.isReady = true
        this.$store.commit('setPageLoading', false)
      },
      onSetTextProductGroup (index) {
        if (this.productGroupList[index].title === '' && this.productGroupList[index].pointMinPercent === '') {
          this.$delete(this.productGroupList, index)
        } else if (this.productGroupList.length - 1 === index) {
          this.productGroupList.push({
            id: 0,
            title: '',
            pointMinPercent: '',
            skuIdList: [],
            skuList: [],
            dialog: false,
            productTreeData: []
          })

          this.getProductCategory(index + 1)
            .then((data) => {
              this.productGroupList[index + 1].productTreeData = data
            })
            .catch((e) => {
              console.log(e)
            })
        }
      },
      onPointChecked (node) {
        if (node.data.type === 'folder' && !~this.pointFolderIdList.indexOf(node.data.id)) {
          this.pointFolderIdList.push(node.data.id)
        }
        if (node.data.type === 'point' && !~this.pointIdList.indexOf(node.data.id)) {
          this.pointIdList.push(node.data.id)
        }
      },
      onPointUnchecked (node) {
        if (node.data.type === 'folder') {
          let position = this.pointFolderIdList.indexOf(node.data.id)
          if (~position) this.pointFolderIdList.splice(position, 1)
          for (let i = 0; i < node.children.length; i++) {
            if (node.children[i].states.checked) {
              if (node.children[i].data.type === 'folder') {
                let position = this.pointFolderIdList.indexOf(node.children[i].data.id)
                if (!~position) this.pointFolderIdList.push(node.children[i].data.id)
              }
              if (node.children[i].data.type === 'point') {
                let position = this.pointIdList.indexOf(node.children[i].data.id)
                if (!~position) this.pointIdList.push(node.children[i].data.id)
              }
            }
          }
        }
        if (node.data.type === 'point') {
          let position = this.pointIdList.indexOf(node.data.id)
          if (~position) this.pointIdList.splice(position, 1)
        }
      },
      onProductSkuChecked (node) {
        if (node.data.type === 'sku' && !~this.productGroupList[node.data.groupIndex].skuIdList.indexOf(node.data.id)) {
          this.productGroupList[node.data.groupIndex].skuIdList.push(node.data.id)
          this.productGroupList[node.data.groupIndex].skuList.push(node.data.text)
        }
      },
      onProductSkuUnchecked (node) {
        if (node.data.type === 'sku') {
          let position = this.productGroupList[node.data.groupIndex].skuIdList.indexOf(node.data.id)
          if (~position) {
            this.productGroupList[node.data.groupIndex].skuIdList.splice(position, 1)
            this.productGroupList[node.data.groupIndex].skuList.splice(position, 1)
          }
        }
      },
      onClickSkuSelectBtn (productGroupIndex) {
        this.productGroupList[productGroupIndex].dialog = true
      },
      async onClickCreateRecommendation () {
        let pointTree = null
        for (let i = 0; i < this.$refs.form.$children.length; i++) {
          if (typeof this.$refs.form.$children[i].tree !== 'undefined') {
            if (this.$refs.form.$children[i].options.treeType === 'pointTree') {
              pointTree = this.$refs.form.$children[i].model
            }
          }
        }

        this.filterChildrenPointIdList(pointTree)

        let recommendationData = {
          id: this.id,
          title: this.recommendationTitle,
          bonusPercent: this.bonusPercent,
          refundPercent: this.refundPercent,
          startDate: this.startDate + ' 00:00:00',
          endDate: this.endDate + ' 00:00:00'
        }

        if (this.bonusMaxSum !== null) {
          recommendationData.bonusMaxSum = this.bonusMaxSum
        }

        if (this.description !== null) {
          recommendationData.description = this.description
        }

        if (this.minOrderSum !== null) {
          recommendationData.minOrderSum = this.minOrderSum
        }

        if (this.minOrderWeight !== null) {
          recommendationData.minOrderWeight = this.minOrderWeight
        }

        if (this.pointFolderIdList.length > 0) {
          recommendationData.pointFolderIdList = this.pointFolderIdList
        }
        if (this.pointIdList.length > 0) {
          recommendationData.pointIdList = this.pointIdList
        }

        if (this.productGroupList.length > 1) {
          recommendationData.productGroupList = []
          for (let i = 0; i < this.productGroupList.length - 1; i++) {
            recommendationData.productGroupList[i] = {
              id: this.productGroupList[i].id,
              title: this.productGroupList[i].title,
              product_sku_id_list: this.productGroupList[i].skuIdList
            }
          }
        }

        await this.$store.dispatch('createRecommendation', recommendationData)
          .then((data) => {
            if (typeof data.recommendation !== 'undefined') {
              this.$router.push('/recommendations/single/' + data.recommendation.id)
            }
          })
          .catch((e) => {
            console.log(e)
          })
      },
      minDate () {
        let date = new Date()
        date.setHours(24)
        return this.$moment(date).format('YYYY-MM-DD')
      },
      checkValidate () {
        if (this.startDate === null) {
          this.valid = false
        } else if (this.endDate === null) {
          this.valid = false
        } else if (this.recommendationTitle === null || this.recommendationTitle === '') {
          this.valid = false
        } else if (this.bonusPercent === null) {
          this.valid = false
        } else if (this.refundPercent === null) {
          this.valid = false
        } else {
          this.valid = true
        }
        return this.valid
      },
      onCreated () {
        this.$store.commit('setPageLoading', true)

        this.id = null
        this.recommendationTitle = null
        this.description = null
        this.bonusPercent = null
        this.refundPercent = null
        this.bonusMaxSum = null
        this.minOrderSum = null
        this.minOrderWeight = null
        this.startDate = null
        this.endDate = null
        this.pointListTreeData = []
        this.pointFolderIdList = []
        this.pointIdList = []
        this.pointTreeData = []
        this.pointTreeIdCounter = 0
        this.productCategoryTree = []
        this.productGroupList = [
          {
            id: 0,
            title: '',
            pointMinPercent: null,
            skuIdList: [],
            skuList: [],
            dialog: false,
            productTreeData: []
          }
        ]

        this.breadcrumbs = [
          {name: 'Главная', link: '/'},
          {name: 'Рекомендации', link: '/recommendations/active'}
        ]

        if (this.$router.currentRoute.path.indexOf('/recommendations/edit/') !== -1) {
          this.id = parseInt(this.$route.params.id)
          this.title = 'Редактировать рекомендацию'
          this.$store.dispatch('getRecommendationSingle', {id: this.id})
          this.breadcrumbs.push({name: 'Редактировать рекомендацию'})
        } else {
          this.id = null
          this.title = 'Новая рекомендация'
          this.breadcrumbs.push({name: 'Новая рекомендация'})

          this.getPointFolder(0)
            .then((data) => {
              this.pointTreeData = data
              this.pageDataReady.points = true
              this.pageDataStatus()
            })
            .catch((e) => {
              console.log(e)
            })

          this.getProductCategory(0)
            .then((data) => {
              this.productGroupList[0].productTreeData = data
              this.pageDataReady.products = true
              this.pageDataStatus()
            })
            .catch((e) => {
              console.log(e)
            })
        }
        this.$store.commit('setPageTitle', this.title)
      },
      async getPointFolder (nodeId) {
        let folder
        await this.$store.dispatch('getPointFolderList', {id: nodeId, mode: 'active'})
          .then((data) => {
            if (this.id !== null && this.recommendationData !== null) {
              folder = this.pointTreeDataStructure([data], false, this.recommendationData.point_folder_tree)[0].children
            } else {
              folder = this.pointTreeDataStructure([data])[0].children
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return folder
      },
      async getProductCategory (groupIndex) {
        let categoryList = []
        await this.$store.dispatch('getProductCategoryList')
          .then((data) => {
            for (let i = 0; i < data.product_category_list.length; i++) {
              categoryList[i] = {
                text: data.product_category_list[i].title,
                data: {
                  id: data.product_category_list[i].id,
                  type: 'category',
                  groupIndex: groupIndex
                },
                id: this.productTreeIdCounter++,
                isBatch: true
              }
              categoryList[i].state = { checkbox: false }
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return categoryList
      },
      async getProductBrand (categoryId, groupIndex) {
        let brandList = []
        await this.$store.dispatch('getProductBrandList', {id: categoryId})
          .then((data) => {
            for (let i = 0; i < data.product_category_brand_list.length; i++) {
              brandList[i] = {
                text: data.product_category_brand_list[i].title,
                data: {
                  id: data.product_category_brand_list[i].id,
                  productBrandId: data.product_category_brand_list[i].product_brand_id,
                  type: 'brand',
                  groupIndex: groupIndex
                },
                id: this.productTreeIdCounter++,
                isBatch: true
              }
              brandList[i].state = { checkbox: false }
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return brandList
      },
      async getProductSku (brandId, groupIndex) {
        let skuList = []
        await this.$store.dispatch('getProductSkuList', {id: brandId})
          .then((data) => {
            for (let i = 0; i < data.product_sku_list.length; i++) {
              skuList[i] = {
                text: data.product_sku_list[i].title,
                data: {
                  id: data.product_sku_list[i].id,
                  type: 'sku',
                  groupIndex: groupIndex
                },
                id: this.productTreeIdCounter++,
                isBatch: false
              }

              let productIdPosition = this.productGroupList[groupIndex].skuIdList.indexOf(data.product_sku_list[i].id)
              let productChecked = false
              if (~productIdPosition) {
                productChecked = true
              }
              skuList[i].state = { checked: productChecked, checkbox: true }
            }
          })
          .catch((e) => {
            console.log(e)
          })
        return skuList
      },
      isChildrenInPointTree (id, tree) {
        if (tree !== null && typeof tree !== 'undefined') {
          for (let i = 0; i < tree.length; i++) {
            let isId = tree[i].id === id
            let isFolders = typeof tree[i].point_folder_list !== 'undefined' ? tree[i].point_folder_list.length > 0 : false
            let isPoints = typeof tree[i].point_list !== 'undefined' ? tree[i].point_list.length > 0 : false

            if (isId && (isFolders || isPoints)) {
              return true
            } else if (isFolders) {
              if (this.isChildrenInPointTree(id, tree[i].point_folder_list)) {
                return true
              }
            }
          }
        }
        return false
      },
      pointTreeDataStructure (pointFolderList, folderChecked = false, indeterminateTree = null) {
        let resultList = []

        for (let i = 0; i < pointFolderList.length; i++) {
          resultList[i] = {}

          if (typeof pointFolderList[i].title !== 'undefined') {
            resultList[i].text = pointFolderList[i].title
          }

          if (typeof pointFolderList[i].id !== 'undefined') {
            resultList[i].data = {
              id: pointFolderList[i].id,
              type: 'folder'
            }
            resultList[i].id = this.pointTreeIdCounter++
            resultList[i].isBatch = pointFolderList[i].have_children
          }

          let folderIdPosition = this.pointFolderIdList.indexOf(pointFolderList[i].id)
          let currentFolderChecked = false
          if (~folderIdPosition || folderChecked) {
            currentFolderChecked = true
          }
          resultList[i].state = { checked: currentFolderChecked }

          if (!currentFolderChecked && indeterminateTree !== null) {
            resultList[i].state.indeterminate = this.isChildrenInPointTree(pointFolderList[i].id, indeterminateTree)
            resultList[i].state.expanded = this.isChildrenInPointTree(pointFolderList[i].id, indeterminateTree)
          }

          if (typeof pointFolderList[i].point_folder_list !== 'undefined') {
            resultList[i].children = []
            resultList[i].children = this.pointTreeDataStructure(pointFolderList[i].point_folder_list, folderChecked, indeterminateTree)
          }

          if (typeof pointFolderList[i].point_list !== 'undefined') {
            if (typeof resultList[i].children === 'undefined') {
              resultList[i].children = []
            }

            for (let j = 0; j < pointFolderList[i].point_list.length; j++) {
              let index = resultList[i].children.length
              resultList[i].children[index] = {
                text: pointFolderList[i].point_list[j].title,
                data: {
                  id: pointFolderList[i].point_list[j].id,
                  type: 'point'
                }
              }
              let pointIdPosition = this.pointIdList.indexOf(pointFolderList[i].point_list[j].id)
              let pointChecked = false
              if (~pointIdPosition || currentFolderChecked) {
                pointChecked = true
              }
              resultList[i].children[index].state = { checked: pointChecked }
            }
          }
        }
        return resultList
      },
      filterChildrenPointIdList (tree, deleteThis = false) {
        for (let i = 0; i < tree.length; i++) {
          if (tree[i].data.type === 'folder') {
            let folderIdPosition = this.pointFolderIdList.indexOf(tree[i].data.id)
            if (~folderIdPosition) {
              if (deleteThis) {
                this.pointFolderIdList.splice(folderIdPosition, 1)
              }
              this.filterChildrenPointIdList(tree[i].children, true)
            } else {
              if (deleteThis) {
                this.filterChildrenPointIdList(tree[i].children, true)
              } else {
                this.filterChildrenPointIdList(tree[i].children, false)
              }
            }
          } else if (tree[i].data.type === 'point') {
            let pointIdPosition = this.pointIdList.indexOf(tree[i].data.id)
            if (~pointIdPosition && deleteThis) {
              this.pointIdList.splice(pointIdPosition, 1)
            }
          }
        }
      },
      async pointTreeLoader (id = 0) {
        this.pointLoading = true
        let pointTreeData = await this.$store.dispatch('getPointFolderList', {id: id, mode: 'active'})
          .then((data) => {
            return data
          })
          .catch((e) => {
            console.log(e)
          })

        if (typeof pointTreeData.point_folder_list !== 'undefined') {
          for (let i = 0; i < pointTreeData.point_folder_list.length; i++) {
            if (this.isChildrenInPointTree(pointTreeData.point_folder_list[i].id, this.recommendationData.point_folder_tree)) {
              let child = await this.pointTreeLoader(pointTreeData.point_folder_list[i].id)
              pointTreeData.point_folder_list[i].point_folder_list = child.point_folder_list
              pointTreeData.point_folder_list[i].point_list = child.point_list
            }
          }
        }

        if (id === 0) {
          this.pointTreeData = this.pointTreeDataStructure([pointTreeData], false, this.recommendationData.point_folder_tree)[0].children
          this.pointLoading = false
          this.pageDataReady.points = true
          this.pageDataStatus()
        } else {
          return pointTreeData
        }
      }
    },
    computed: {
      loading () {
        return this.$store.getters.loading
      },
      recommendationData () {
        return this.$store.getters.recommendationSingle
      },
      productList () {
        return this.$store.getters.productList
      }
    },
    created () {
      this.onCreated()
    },
    watch: {
      '$route' (to, from) {
        this.onCreated()
      },
      recommendationData (newRecommendation, oldRecommendation) {
        if (this.recommendationData !== null && this.recommendationData !== undefined) {
          this.recommendationTitle = this.recommendationData.title
          this.startDate = this.$moment(this.recommendationData.start_date).format('YYYY-MM-DD')
          this.endDate = this.$moment(this.recommendationData.end_date).format('YYYY-MM-DD')
          this.bonusPercent = this.recommendationData.bonus_percent
          this.refundPercent = this.recommendationData.refund_percent

          if (typeof this.recommendationData.bonus_max_sum !== 'undefined') {
            this.bonusMaxSum = this.recommendationData.bonus_max_sum
          }

          if (typeof this.recommendationData.description !== 'undefined') {
            this.description = this.recommendationData.description
          }

          if (typeof this.recommendationData.min_order_sum !== 'undefined') {
            this.minOrderSum = this.recommendationData.min_order_sum
          }

          if (typeof this.recommendationData.min_order_weight !== 'undefined') {
            this.minOrderWeight = this.recommendationData.min_order_weight
          }
          if (typeof this.recommendationData.point_folder_list !== 'undefined') {
            this.pointFolderIdList = []
            for (let i = 0; i < this.recommendationData.point_folder_list.length; i++) {
              this.pointFolderIdList.push(this.recommendationData.point_folder_list[i].id)
            }
          }

          if (typeof this.recommendationData.point_list !== 'undefined') {
            this.pointIdList = []
            for (let i = 0; i < this.recommendationData.point_list.length; i++) {
              this.pointIdList.push(this.recommendationData.point_list[i].id)
            }
          }

          if (typeof this.recommendationData.recommendation_product_group_list !== 'undefined') {
            let productGroupList = []
            for (let i = 0; i < this.recommendationData.recommendation_product_group_list.length; i++) {
              productGroupList[i] = {
                id: this.recommendationData.recommendation_product_group_list[i].id,
                title: this.recommendationData.recommendation_product_group_list[i].title,
                skuIdList: [],
                skuList: [],
                treeData: [],
                dialog: false,
                productTreeData: [],
                productTreeIdCounter: 0
              }

              for (let k = 0; k < this.recommendationData.recommendation_product_group_list[i].product_sku_list.length; k++) {
                productGroupList[i].skuIdList[k] = this.recommendationData.recommendation_product_group_list[i].product_sku_list[k].id
                productGroupList[i].skuList[k] = this.recommendationData.recommendation_product_group_list[i].product_sku_list[k].title
              }
            }
            this.productGroupList = productGroupList.concat(this.productGroupList)

            for (let i = 0; i < this.productGroupList.length; i++) {
              if (this.productGroupList[i].id !== null) {
                this.getProductCategory(i)
                  .then((data) => {
                    this.productGroupList[i].productTreeData = data
                    if (i + 1 === this.productGroupList.length) {
                      this.pageDataReady.products = true
                      this.pageDataStatus()
                    }
                  })
                  .catch((e) => {
                    console.log(e)
                  })
              }
            }
          }

          // this.$store.dispatch('getPointList')
          // this.$store.dispatch('getProductList')

          // this.getPointFolder(0)
          //   .then((data) => {
          //     this.pointTreeData = [data[0]]
          //   })
          //   .catch((e) => {
          //     console.log(e)
          //   })
          this.pointTreeLoader()
        }
      },
      productList (n, o) {
        // for (let i = 0; i < this.productGroupList.length; i++) {
        //   this.productGroupList[i].treeData = this.productTreeDataStructure(this.productList, i, this.productGroupList[i].skuIdList)
        // }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Recommendations/RecommendationNew.vue